import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
declare var UIkit: any;
@Component({
    selector: 'app-tisco-card',
    templateUrl: './tisco-card.component.html',
    styleUrls: ['./tisco-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoCardComponent implements OnInit {

  @Input() titleCard: string;
  @Input() descriptionCard: string;
  @Input() imagesCard: string;
  @Input() imagesMobileCard: string;
  @Input() linkIDCard: string;
  @Input() dateCard: any;
  @Input() timeStampCard: any;

  constructor() { }

  ngOnInit() {}

}
